/* app/js/src/components/graphics/edit/fields/text-link.component.scss */
.cursor-pointer {
  cursor: pointer;
}
input {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
input:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
input::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
input.ng-invalid.ng-dirty,
input.ng-invalid.ng-touched {
  border-color: #ef5350;
}
.container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
label {
  color: #7d8fa1;
  font-size: 12px;
  letter-spacing: 0.1px;
  margin-right: 10px;
}
input {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
/*# sourceMappingURL=text-link.component.css.map */
